"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthLogin = void 0;
const builder_1 = require("./builder");
const constants_1 = require("./constants");
const interface_1 = require("./interface");
const utils_1 = require("./utils");
class AuthLogin {
    constructor({ loginUrl = constants_1.DEFAULT_LOGIN_URL, screen = interface_1.ScreenType.PHONE_INPUT_SCREEN, clientId, phoneNumber, onSuccess, onError, onClose, enableScrollOnClose = true, onEdit, closeOnEdit, }) {
        this.iframeConfig = {
            id: 'auth-iframe',
            style: {},
        };
        this.handleEditClick = (onEdit, closeOnEdit) => {
            onEdit();
            if (closeOnEdit) {
                this.closeScreen();
                return;
            }
        };
        try {
            this.loginUrl = (0, builder_1.buildLoginUrl)({
                loginUrl: (0, utils_1.getAbsoluteLoginUrl)(loginUrl),
                screen,
                phoneNumber,
                clientId,
                customEdit: (!!closeOnEdit)
            });
            this.screen = screen;
            this.eventCallbacks = {
                [interface_1.LOGIN_STATUS.SUCCESS]: onSuccess,
                [interface_1.LOGIN_STATUS.FAILURE]: onError,
                [interface_1.LOGIN_STATUS.PHONE_NUMBER_INCORRECT]: onError,
                [constants_1.ON_CLOSE]: onClose,
                [interface_1.IFRAME_MESSAGE.EDIT_CLICKED]: this.handleEditClick.bind(this, onEdit, closeOnEdit),
            };
            window.addEventListener('message', this.handlePostMessage.bind(this));
            this.enableScrollOnClose = enableScrollOnClose;
            this.init();
        }
        catch (e) {
            console.error('Unable to initialize SDK, error:', e);
        }
    }
    openPhoneInputScreen() {
        const { id } = this.iframeConfig;
        if (document.getElementById(id)) {
            console.warn('Iframe already exists');
            return;
        }
        const overlayDiv = this.createOverlay();
        const wrapper = this.createWrapper();
        const iframe = this.createIframe();
        const closeButton = this.createCloseButton();
        overlayDiv.appendChild(wrapper);
        wrapper.appendChild(iframe);
        wrapper.appendChild(closeButton);
        document.body.appendChild(overlayDiv);
        (0, utils_1.bindResponsiveStyles)({
            component: wrapper,
            componentName: 'WRAPPER',
            finalStylesApplied: true,
        });
    }
    createOverlay() {
        const overlayDiv = document.createElement('div');
        overlayDiv.id = constants_1.STYLES.overlay.id;
        Object.assign(overlayDiv.style, constants_1.STYLES.overlay);
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.style.touchAction = 'none';
        overlayDiv.addEventListener('click', () => {
            var _a, _b;
            (_b = (_a = this.eventCallbacks)[constants_1.ON_CLOSE]) === null || _b === void 0 ? void 0 : _b.call(_a);
            this.closeScreen();
        });
        return overlayDiv;
    }
    createWrapper() {
        const wrapper = document.createElement('div');
        wrapper.id = constants_1.STYLES.wrapper.id;
        Object.assign(wrapper.style, constants_1.STYLES.wrapper);
        return wrapper;
    }
    createIframe() {
        const iframe = document.createElement('iframe');
        iframe.src = this.loginUrl || '';
        iframe.id = this.iframeConfig.id;
        iframe.setAttribute("sandbox", constants_1.SANDBOX_PROP);
        Object.assign(iframe.style, constants_1.STYLES.iframe);
        return iframe;
    }
    createCloseButton() {
        const closeButton = document.createElement('button');
        Object.assign(closeButton.style, constants_1.STYLES.closeButton);
        const closeIcon = document.createElement('img');
        closeIcon.src = constants_1.CLOSE_BUTTON_URL;
        closeIcon.alt = 'Close';
        Object.assign(closeIcon.style, constants_1.STYLES.closeIcon);
        closeButton.appendChild(closeIcon);
        closeButton.addEventListener('click', () => {
            var _a, _b;
            (_b = (_a = this.eventCallbacks)[constants_1.ON_CLOSE]) === null || _b === void 0 ? void 0 : _b.call(_a);
            this.closeScreen();
        });
        (0, utils_1.bindResponsiveStyles)({
            component: closeButton,
            componentName: 'CLOSE_ICON',
        });
        return closeButton;
    }
    handlePostMessage(event) {
        var _a;
        if (((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.type) === interface_1.IFRAME_MESSAGE.HEIGHT_RESIZE) {
            (0, utils_1.handleHeightResize)(event.data);
        }
        const callback = this.eventCallbacks[event.data];
        if (callback) {
            callback();
            if (event.data === interface_1.LOGIN_STATUS.SUCCESS) {
                this.closeScreen();
            }
        }
    }
    closeScreen() {
        var _a;
        const iframeOverlay = document.getElementById(constants_1.STYLES.overlay.id);
        (_a = iframeOverlay === null || iframeOverlay === void 0 ? void 0 : iframeOverlay.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(iframeOverlay);
        this.removeEventListener();
        if (this.enableScrollOnClose) {
            document.documentElement.style.overflow = '';
            document.documentElement.style.touchAction = '';
        }
    }
    removeEventListener() {
        window.removeEventListener('message', this.handlePostMessage.bind(this));
    }
    init() {
        this.closeScreen();
        this.openPhoneInputScreen();
    }
}
exports.AuthLogin = AuthLogin;
exports.default = AuthLogin;
//# sourceMappingURL=auth-login-module.js.map